import {
  Navigate,
  useRouterState,
} from "@tanstack/react-router"
import type {
  FC,
  ReactNode,
} from "react"
import { useEffect } from "react"
import { ThemeComponent } from "./ThemeComponent"
import {
  ApiContextProvider,
  CountrySelectionContextProvider,
  useAuthContext,
  useSessionStorageContext,
  useCountrySelectionContext,
} from "src/contexts"
import { TrackingTechnologyConsent } from "src/pages"

interface Props {
  children?: ReactNode;
}

function DeauthApiContextProvider(props: Props) {
  const { country } = useCountrySelectionContext()

  return (
    <ApiContextProvider baseURL={country?.sugarmate_api_base_url}>
      {props.children}
    </ApiContextProvider>
  )
}

export function getDeauthProtectedComponent(Component: FC<object>) {
  return function DeauthProtectedComponent() {
    const currentPath = useRouterState({
      // note use .href if you want to include query params
      select: (s) => s.resolvedLocation.pathname,
    })

    const {
      isAuthenticated,
      isExpired,
    } = useAuthContext()

    const {
      loginRedirect,
      logoutRedirect,
      setLogoutRedirect,
    } = useSessionStorageContext()

    useEffect(
      () => {
        const isValid = isAuthenticated && !isExpired

        // if this path was the logout redirect and it loaded successfully,
        // then clear the logout redirect
        if (isValid && logoutRedirect === currentPath) {
          setLogoutRedirect()
        }
      },
      [
        isExpired,
        isAuthenticated,
        logoutRedirect,
        currentPath,
        setLogoutRedirect,
      ],
    )

    return !isAuthenticated ? (
      <ThemeComponent>
        <TrackingTechnologyConsent>
          <CountrySelectionContextProvider>
            <DeauthApiContextProvider>
              <Component />
            </DeauthApiContextProvider>
          </CountrySelectionContextProvider>
        </TrackingTechnologyConsent>
      </ThemeComponent>
    ) : (
      <Navigate
        to={loginRedirect}
        params={{}}
        search={{}}
        replace
      />
    )
  }
}
